import { Pipe, PipeTransform } from "@angular/core";
import { TranslationService } from "@core-services/translation.service";

@Pipe({
	name: "percent_symbol",
	standalone: false
})
export class PercentSymbolPipe implements PipeTransform {
	public transform(value: string | number, handleTrPercentageSymbol = true): string {
		const isoCode: string = TranslationService.getLanguageIsoCode();

		// Edge case for Turkish, the "%" sign comes before the value
		if (isoCode === "tr" && handleTrPercentageSymbol) {
			let sign = "";
			const strValue: string = value + "";
			if (["+", "-"].some((s: string) => strValue[0] === s)) {
				// The "%" sign must be between the "+/-" sign and the value
				sign = strValue[0];
				value = strValue.slice(1);
			}
			return sign + "%" + value;
		}

		const suffix: string = ["fr", "es"].some((lang) => lang === isoCode) ? " %" : "%";
		return value + suffix;
	}
}
